<template>
     <div class='mdl-mini-footer'>
        <a href="https://www.prolexis.com" title="Visiter le site de Diagonal" target="_blank">
            <img id="imageLogoDiagonal" src="@/assets/images/espaceur.png" alt="Diagonal" height="auto" width="auto">
        </a>
    </div>
</template>

<script>
    export default {
        name: "FooterPL"
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.mdl-mini-footer {
    position: relative;
    height: 70px;
    width: 100%;
	padding: 0;
	margin: 0;
    clear: both;
    z-index: 3;
	background-color: #fff;
	background-image: url("@/assets/images/DiagonalLogo.png");
	background-repeat: no-repeat;
	background-size: 220px;
	background-position: 25px 8px;
    border-top-color: #EFEFEF;
    border-top-style: solid;
    border-top-width: thin;
}

#imageLogoDiagonal {
	padding: 0;
	margin: 0;
	width: auto;
	height: 70px;
}

</style>
